import { render, staticRenderFns } from "./PointsHistory.vue?vue&type=template&id=07353ba2&scoped=true&"
import script from "./PointsHistory.vue?vue&type=script&lang=js&"
export * from "./PointsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07353ba2",
  null
  
)

export default component.exports